<template>
  <div class="layout-menu">
    <el-menu mode="horizontal" :default-active="$route.path" background-color="#263554" text-color="#AAAEB7" active-text-color="#fff" router>
      <template v-for="(item, i) in menuList">
        <el-submenu v-if="item.children" :key="i" :index="item.path">
          <template slot="title">
            <span>{{ item.meta.title }}</span>
            <i class="iconfont icon-xiajiantou" />
          </template>
          <el-menu-item v-for="(val, index) in item.children" :key="`${i}-${index}`" :index="val.path">
            {{ val.meta.title }}
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else-if="item.meta.show" :key="i" :index="item.path">
          <span slot="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'LayoutMenu',
  data () {
    return {
      menuList: [],
      userInfo: JSON.parse(localStorage.getItem('user_info'))
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.menuList = this.$router.options.routes[0].children
      if (this.userInfo.roles === 1) {
        this.menuList = this.menuList.filter(v => {
          return ['系统首页', '新建单号', '卖家单号列表', '销售认领列表', '卖家批量列表', '批量导入'].includes(v.meta.title)
        })
      } else if (this.userInfo.roles === 2) {
        this.menuList = this.menuList.filter(v => ['系统首页', '新建单号', '下家单号列表', '批量导入'].includes(v.meta.title))
      }
    }
  }
}
</script>

<style lang="less">
.el-menu-item:hover{
  background: transparent !important;
  color: #e0e0e0 !important;
}
.el-submenu__title:hover {
  background: transparent !important;
  color: #e0e0e0 !important;
}
.el-menu--popup {
  min-width: auto !important;
  padding: 10px;
}
.layout-menu {
  height: 100%;
  .layout-menu-top {
    background: rgb(1, 20, 40);
    color: #fff;
  }
  .el-menu {
    height: 100%;
    border: 0;
    .el-submenu {
      margin-top: 1px;
      .el-submenu__title {
        font-size: 14px !important;
        border-bottom: 0;
      }
    }
    .el-menu-item {
      height: auto;
      line-height: normal;
      border-bottom: 0 !important;
      font-size: 14px;
      padding: 0 16px;
      background: #263554;
    }
    .el-submenu__title {
      display: flex;
      align-items: center;
      justify-content: center;
      height: auto;
      line-height: normal;
      font-size: 12px;
      border-bottom: 0;
      margin-top: 1px;
      padding-left: 8px;
      padding-right: 0;
    }
    .icon-xiajiantou {
      margin-left: 3px;
      font-size: 14px;
      color: #AAAEB7;
    }
    .el-icon-arrow-down:before {
      display: none;
    }
  }
  .layout-menu-top {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    font-size: 24px;
  }
}
</style>
